import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LazyLoadEvent, SelectItem } from 'primeng/api';
import { reportspdf } from 'src/app/models/reportspdf';
import {
    GetMyPatientsQuery,
    Patients,
    raw_patient
} from '../../../../models/patient-profile';
import { PromiseResult, ServerError } from '../../../../models/PromiseResult';
import { CountriesService } from '../../../../services/countries.service';
import { DoctorsService } from '../../../../services/doctors.service';
import { DoctorBreadcrumbService } from '../breadcrumb.service';
import { Title } from '@angular/platform-browser';
import {
    DateUtilService,
    moment_duration
} from '../../../../utilities/date.util.service';
import { TraceClassDecorator } from '@sentry/angular';
import { ProviderStateService } from 'src/app/services/provider-state.service';

@TraceClassDecorator()
@Component({
    selector: 'app-patients',
    templateUrl: './patients.component.html',
    styleUrls: [
        '../../../../../assets/css/custom-egd.css',
        '../../../../../assets/css/print-prescription.css'
    ]
})
export class PatientsComponent implements OnInit {
    openDialog: boolean;
    patient_guid: string;
    consultation_id: number;
    patients: Patients[] = [];
    private user_guid: string;
    pre_patients: raw_patient[] = [];
    response: PromiseResult;
    serverError: ServerError;
    posting: boolean;
    query: GetMyPatientsQuery;
    countries: SelectItem[] = [];
    disabledDates: boolean = true;
    maxDate: Date = new Date();
    showPrescriptiond: string = 'showPrescription';
    showDoctorReportsd: string = 'showDoctorReports';
    printContent: string = 'print-content';

    prescriptionData: reportspdf;
    prescriptionSuccessd: boolean = null;

    doctorReportsData: reportspdf;
    doctorReportsSuccessd: boolean = null;
    displayModel: boolean = false;
    displayModel1: boolean = false;

    loading1: boolean = false;
    loading2: boolean = false;
    loading3: boolean = false;
    loading: boolean = false;
    total_records: number = 0;
    invalid_date_message: boolean = false;
    provider_id: string = "";
    slug: string = "";
    constructor(
        private readonly router: Router,
        private readonly breadcrumbService: DoctorBreadcrumbService,
        private readonly doctorsService: DoctorsService,
        private readonly countryService: CountriesService,
        private readonly titleService: Title,
        private readonly dateUtil: DateUtilService,
        private readonly providerStateService: ProviderStateService
    ) {
        
        this.posting = false;
        this.loading = false;
    }

    async ngOnInit(): Promise<void> {
        this.titleService.setTitle('Dashboard - Past Consultations');
        this.slug = this.providerStateService.getProviderSlug();
        this.breadcrumbService.setItems([
            { label: 'Dashboard', routerLink:['/', this.slug, 'doctor']
            },
            { label: 'Past Consultations' }
        ]);
        this.provider_id = this.providerStateService.getProviderId();
        this.response = {
            success: null,
            error: null,
            data: null
        };
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        };
        this.openDialog = false;
        this.user_guid = sessionStorage.getItem('userid');
        await this.InitFilter(false);
        await this.GetPatients(null);
        this.patient_guid = null;
        this.consultation_id = null;
        this.loading = false;
        await this.FetchCountries();
    }

    Close() {
        this.patient_guid = null;
        this.consultation_id = null;
    }

    async InitFilter(call_api: boolean) {
        this.disabledDates = true;
        this.invalid_date_message = false;
        this.query = {
            user_guid: this.user_guid,
            page_no: 1,
            records_per_page: 10,
            from_date: null,
            to_date: null,
            country_id: null,
            consultation_type_id: null,
            specialty_id: null,
            returnCount: true,
            first: 0,
        };
        if (call_api)
            await this.GetPatients(null);
    }

    async GetPatients(event: LazyLoadEvent) {
        if (!this.disabledDates && (this.query.from_date == null || this.query.to_date == null)) {
            this.invalid_date_message = true;
            return;
        }
        if (this.invalid_date_message && ((this.query.from_date != null && this.query.to_date != null) || this.disabledDates))
            this.invalid_date_message = false;

        this.posting = true;
        this.loading = true;
        if (event != null) {
            this.query.page_no = event.first / event.rows + 1;
            this.query.records_per_page = event.rows;
        }
        else {
            this.query.page_no = 1;
            this.query.first = 0;
        }

        this.patients = [];
        await this.doctorsService
            .GetAllPatients(this.query)
            .toPromise()
            .then(async (result: PromiseResult) => {
                this.response = result;
                if (result.success) {
                    this.total_records = result.data.count;
                    this.pre_patients = result.data.rows;
                    await this.processpatients();
                }
                this.posting = false;
                this.loading = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.serverError = error.error;
                this.response.success = false;
                this.posting = false;
                this.loading = false;
            });
    }

    private async processpatients(): Promise<void> {
        const temp: Patients[] = [];
        this.pre_patients.forEach((patient, index) => {
            temp.push({
                sr_no: index +
                    1 +
                    (this.query.page_no - 1) *
                    this.query.records_per_page,
                patient_guid: patient.patient_guid,
                consultation_id: patient.id,
                name:
                    patient.accounts.first_name +
                    ' ' +
                    (patient.accounts.middle_name==null?'':patient.accounts.middle_name) +
                    ' ' +
                    patient.accounts.last_name,
                age:
                    this.dateUtil.diff(
                        patient.accounts.date_of_birth,
                        new Date(),
                        moment_duration.years
                    ) + ' Yrs',
                country: patient.accounts.country.country_name,
                opinion_type: patient.priority_type.consultation_name,
                consultation_date: patient.consultation_date,
                req_no: patient.consultation_request_number
            });
        });
        this.patients = temp;
    }

    private async FetchCountries(): Promise<void> {
        this.posting = true;
        await this.countryService
            .getCountries(this.provider_id)
            .toPromise()
            .then((result) => {
                this.countries = [
                    {
                        label: 'All',
                        value: null
                    }
                ];
                for (const country of result)
                    this.countries.push({
                        label: country.country_name,
                        value: country.id
                    });
                this.posting = false;
            });
    }

    ShowProfile(patient: Patients) {
        this.loading1 = true;
        this.consultation_id = patient.consultation_id;
        this.patient_guid = patient.patient_guid;
        this.loading1 = false;
        this.openDialog = true;
    }

    RouterNavigation(path: string) {
        this.router.navigate(['/doctor/' + path]);
    }

    private async GetPrescriptionData() {
        await this.doctorsService
            .GetDoctorReportspdf(
                this.patient_guid,
                this.consultation_id,
                'prescription'
            )
            .toPromise()
            .then((result) => {
                this.prescriptionSuccessd = result.success;
                if (result.success) {
                    this.response = result;
                    this.prescriptionData = result.data;
                }
                this.displayModel = true;
            });
    }

    private async GetDoctorReportsData() {
        await this.doctorsService
            .GetDoctorReportspdf(
                this.patient_guid,
                this.consultation_id,
                'report'
            )
            .toPromise()
            .then((result) => {
                this.doctorReportsSuccessd = result.success;
                if (result.success) {
                    this.response = result;
                    this.doctorReportsData = result.data;
                }
                this.displayModel1 = true;
            });
    }

    print() {
        window.print();
    }

    async CloseDialog(): Promise<void> {
        this.displayModel = false;
        this.displayModel1 = false;
    }
    async gotoReportpdf(patient_row: Patients) {
        this.loading2 = true;
        this.patient_guid = patient_row.patient_guid;
        this.consultation_id = patient_row.consultation_id;
        await this.GetDoctorReportsData();
        this.loading2 = false;
        // this.displayModel1 = true;
    }

    async gotoprescription(patient_row: Patients) {
        this.loading3 = true;
        this.patient_guid = patient_row.patient_guid;
        this.consultation_id = patient_row.consultation_id;
        await this.GetPrescriptionData();
        this.loading3 = false;
        // this.displayModel = true;
    }
}
